import * as React from "react";
import * as moment from "moment";

const Address = ({indirizzo, comune}) => {
  return (
      <span>
        {indirizzo}, {comune}
      </span>
  )
}

const Date = ({date, format = 'D/M/YYYY'}) => {
  if (!date) return "-";
  return moment( date ).format( format );
}

const Price = ({val, currency = '€'}) => {
  if (!val) return "-";
  const frmt = parseFloat(val).toFixed(2).replace('.', ',').replace(/\d(?=(\d{3})+\.)/g, '$&.');
  return `${frmt} ${currency}`;
}

export {
  Address,
  Date ,
  Price
}


// WEBPACK FOOTER //
// ./src/components/ui/Formatters.tsx